import { configureStore, combineReducers } from "@reduxjs/toolkit";

import userAuthSliceReducer from "./features/user-auth/userAuth.slice";
import listCustomerSliceReducer from "./features/customers/customers.slice";
import listTripSliceReducer from "./features/trips/trips.slice";
import accountsSliceReducer from "./features/accounts/accounts.slice";

/** Action logout chung */
const LOGOUT_ACTION = "app/logout";

/** Root reducer */
const appReducer = combineReducers({
  userAuth: userAuthSliceReducer,
  customers: listCustomerSliceReducer,
  trips: listTripSliceReducer,
  accounts: accountsSliceReducer,
});

/** Reset toàn bộ state khi logout */
const rootReducer = (state: any, action: any) => {
  if (action.type === LOGOUT_ACTION) {
    state = undefined; // ✅ reset toàn bộ store
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

/** Export types */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

/** Export logout action */
export const logoutAction = () => ({ type: LOGOUT_ACTION });
